export default __webpack_public_path__ + "vendor/scripts/jquery.flot.orderBars.min.js";